
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


// renders a given extra
export default function ExtraCard({extraInfo}) {

    return (
        <Box sx={{display:'flex', flexDirection:'column', justifyContent: 'center' }}>
            <Typography variant="h4" sx={{fontSize: '16px', pl: 1, flexShrink: 1}} >
                {extraInfo.name}: + ${extraInfo.cost}
            </Typography>
        </Box>
    )
}